import Button from '@/src/shared/ui/button'
import styled, {css} from 'styled-components'
import theme, {media, mediaSizes} from '@/src/config/theme'
import {FilterCollapse as FilterCollapseComponent} from './filter-collapse'

export const Wrapper = styled.div<{$visible: boolean}>`
  @media ${media.md} {
    display: flex;
    flex-direction: column;
  }

  ${props =>
    !props.$visible &&
    css`
      display: none;
    `}
`

export const Container = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;

  & > * {
    order: 1;
  }

  @media ${media.md} {
    padding: unset;
    border: unset;
    align-items: stretch;
  }
`

export const HeadTitle = styled.div`
  background: ${theme.colors.gray9};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-radius: 10px;
  border: solid 1px ${theme.colors.borderColor3};
  border-bottom: unset;
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  gap: 8px;
`

export const HeadTitleText = styled.div`
  width: 100%;
  text-align: left;
  font-size: 18px;
  font-weight: 450;
`

export const RangeFilter = styled.div`
  align-items: center;
  min-width: 200px;
  width: 100%;
  padding-top: unset;

  & .ant-slider {
    margin: 8.46875px 9.03125px;
  }

  & .ant-slider-horizontal {
    padding-block: 4px;
    height: 16px;
  }
`

export const FiltersList = styled.div`
  width: 100%;
`

export const FilterCollapse = styled(FilterCollapseComponent)`
  border-radius: 0;
  border-bottom: unset;

  ${FiltersList} &:last-child {
    border-bottom: solid 1px ${theme.colors.borderColor3};

    border-end-end-radius: 10px;
    border-end-start-radius: 10px;
  }
`

export const FilterCollapseLabel = styled.div``

export const FilterCollapseTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const FilterCollapseTitleText = styled.span`
  font-size: 1.125rem;
  font-weight: 450;
`

export const ExpandIcon = styled.svg`
  transition: transform 0.3s ease-in-out;
  transform: rotate(-180deg);

  &[data-active='true'] {
    transform: rotate(0deg);
  }
`

export const ButtonFilterValue = styled.div`
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  gap: 6px;
  
  [data-disabled="1"] {
    bacground: ${theme.colors.gray};
  }
`

export const ValuesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ActiveValuesCounter = styled.span`
  font-size: 12px;
  font-weight: 600;
  background: ${theme.colors.primary};
  border-radius: 100%;
  color: black;
  padding: 2px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FilterWrapper = styled.div`
  & > * {
    width: 100%;
  }

  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media ${media.lg} {
    flex: 1;

    &[data-empty] {
      padding: unset;
    }
  }

  @media (max-width: ${mediaSizes.lg}px) {
    &[data-empty] {
      display: none;
    }
  }
`

export const DropdownSelect = styled.div`
  border-radius: unset;
  border: unset;
  box-shadow: unset;
  padding: unset;
  justify-content: flex-start;
  padding-right: 15px;

  @media ${media.lg} {
    & > * {
      width: 100%;
      justify-content: space-between;
    }
  }
`

export const Checkbox = styled.div`
  line-height: 1;
  align-items: center;
  display: flex;

  & label {
    font-size: 1.125rem;
    font-weight: 450;
  }
`

export const BrandFilter = styled(DropdownSelect)``

export const CategoryFilter = styled(DropdownSelect)``

export const CatalogFiltersMobileBtn = styled.button`
  background: transparent;
  border: unset;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-underline-color: ${theme.colors.primary};
  font-weight: 450;
  font-size: 1.125rem;

  box-shadow: unset;

  &:hover {
    color: ${theme.colors.primary};
    border: unset;
  }
`

export const SelectedFiltersTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 10px;
`

export const SelectedFiltersContainer = styled.div`
  order: 2;
  position: relative;
  margin-top: 15px;

  display: flex;
  flex-wrap: wrap;

  gap: 10px;

  & * {
    cursor: pointer;
  }

  @media ${media.md} {
    flex-direction: row;
    align-items: center;
    order: 1;
    margin-top: unset;
  }
`

export const FilterSelectedValue = styled.div`
  padding: 5px;
  border: 1px solid ${theme.colors.gray};
  cursor: pointer;
`

export const ClearFilters = styled.div`
  display: flex;
  align-items: center;
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  
  margin-top: 8px;
  gap: 8px;
`

export const ApplyButton = styled(Button)`
  border-radius: 10px;
`

export const ClearButton = styled(Button)`
  color: white;
  background: oklch(0.637 0.237 25.331);
  border-radius: 10px;
`
